export const EVENTS_CLIENT_MODAL_CSS = `
        .submit-button {
            margin-top: 10px;
        }
        
        #username-modal {
            background: linear-gradient(135deg, #0a0f1e 0%, #121829 50%, #0d1220 100%);
            border: 2px solid #00d9ff;
            border-radius: 16px;
            padding: 2rem;
            box-shadow: 0 0 40px rgba(0, 217, 255, 0.3), 0 0 80px rgba(0, 255, 157, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1);
        }
        
        #username-modal h2 {
            color: #00d9ff;
            text-transform: uppercase;
            letter-spacing: 0.15em;
            text-shadow: 0 0 10px rgba(0, 217, 255, 0.7), 0 0 20px rgba(0, 217, 255, 0.4);
            font-weight: 700;
            margin: 1rem 0;
            font-size: clamp(1rem, 3vw, 1.25rem);
        }
        
        #username-modal input[type="text"],
        #username-modal input[type="password"] {
            background: rgba(10, 15, 30, 0.8);
            color: #00ffff;
            border: 1px solid #00d9ff;
            border-radius: 8px;
            padding: 0.75rem;
            font-size: 1rem;
            font-weight: 600;
            box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.4), 0 0 10px rgba(0, 217, 255, 0.2);
            transition: all 0.3s ease;
        }
        
        #username-modal input[type="text"]:focus,
        #username-modal input[type="password"]:focus {
            outline: none;
            border-color: #00ffff;
            box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.4), 0 0 20px rgba(0, 255, 255, 0.5), 0 0 30px rgba(0, 255, 157, 0.3);
        }
        
        #username-modal input[type="text"]::placeholder,
        #username-modal input[type="password"]::placeholder {
            color: rgba(0, 217, 255, 0.5);
        }

        #username-modal .login-error {
            color: #ff4444;
            font-size: 0.9rem;
            font-weight: 600;
            margin: 0.5rem 0 0;
            text-shadow: 0 0 8px rgba(255, 68, 68, 0.6);
            display: none;
        }

        #username-modal .login-error.visible {
            display: block;
        }
        
        #username-modal input[type="checkbox"] {
            width: 20px;
            height: 20px;
            accent-color: #00ffff;
            cursor: pointer;
            margin-left: 0.5rem;
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            background: rgba(10, 15, 30, 0.8);
            border: 2px solid #00d9ff;
            border-radius: 4px;
            position: relative;
            transition: all 0.3s ease;
            box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.4), 0 0 10px rgba(0, 217, 255, 0.2);
        }
        
        #username-modal input[type="checkbox"]:hover {
            border-color: #00ffff;
            box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.4), 0 0 15px rgba(0, 217, 255, 0.4);
        }
        
        #username-modal input[type="checkbox"]:checked {
            background: linear-gradient(135deg, #00d9ff 0%, #00ff9d 100%);
            border-color: #00ffff;
            box-shadow: 0 0 15px rgba(0, 217, 255, 0.6), 0 0 25px rgba(0, 255, 157, 0.4);
        }
        
        #username-modal input[type="checkbox"]:checked::after {
            content: '\\2713';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #0a0f1e;
            font-size: 16px;
            font-weight: bold;
        }
        
        .modal-container {
            background: radial-gradient(ellipse at center, rgba(10, 15, 30, 0.95) 0%, rgba(0, 5, 15, 0.98) 100%);
            backdrop-filter: blur(8px);
        }
        
        #age-verification-modal {
            background: linear-gradient(135deg, #0a0f1e 0%, #121829 50%, #0d1220 100%);
            border: 2px solid #00d9ff;
            border-radius: 16px;
            padding: 2rem;
            box-shadow: 0 0 40px rgba(0, 217, 255, 0.3), 0 0 80px rgba(0, 255, 157, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1);
            max-width: 500px;
        }
        
        #age-verification-modal h2 {
            color: #00d9ff;
            text-transform: uppercase;
            letter-spacing: 0.15em;
            text-shadow: 0 0 10px rgba(0, 217, 255, 0.7), 0 0 20px rgba(0, 217, 255, 0.4);
            font-weight: 700;
            margin: 1rem 0;
            font-size: clamp(1rem, 3vw, 1.25rem);
        }
        
        #age-verification-modal p {
            color: #00ffff;
            font-size: 1rem;
            line-height: 1.6;
            margin: 1rem 0;
        }
        
        #age-verification-modal .button-container {
            display: flex;
            gap: 1rem;
            margin-top: 2rem;
            flex-direction: column;
        }
        
        #age-verification-modal button {
            padding: 0.75rem 1.5rem;
            font-size: 1rem;
            font-weight: 600;
            border-radius: 8px;
            border: none;
            cursor: pointer;
            transition: all 0.3s ease;
            text-transform: uppercase;
            letter-spacing: 0.05em;
        }
        
        #age-verification-modal .age-confirm-button {
            background: linear-gradient(135deg, #00d9ff 0%, #00ffaa 100%);
            color: #0a0f1e;
            box-shadow: 0 0 20px rgba(0, 217, 255, 0.5);
        }
        
        #age-verification-modal .age-confirm-button:hover {
            box-shadow: 0 0 30px rgba(0, 217, 255, 0.8);
            transform: translateY(-2px);
        }
        
        #age-verification-modal .age-deny-button {
            background: rgba(255, 50, 50, 0.2);
            color: #ff5555;
            border: 1px solid #ff5555;
        }
        
        #age-verification-modal .age-deny-button:hover {
            background: rgba(255, 50, 50, 0.3);
        }
`;

export const AGE_MODAL_HTML = `
        <!-- Age Verification Modal -->
        <div id="age-verification-modal" class="modal-content">
            <h2>Age Verification</h2>
            <p>This application may contain adult content. You must be at least 18 years of age to continue.</p>
            <p>By clicking "I am 18 or older", you confirm that you meet the minimum age requirement.</p>
            <div class="button-container">
                <button id="age-confirm-button" class="age-confirm-button">I am 18 or older</button>
                <button id="age-deny-button" class="age-deny-button">I am under 18</button>
            </div>
        </div>
`;

export const USER_MODAL_HTML = `
        <!-- Username Modal -->
        <div id="username-modal" class="modal-content">
            <form onsubmit="return false;" autocomplete="on">
            <h2>Enter Your Name:
            <input type="text" id="username-input" class="username-input" placeholder="Username" autocomplete="username" onkeydown="event.stopPropagation()"></h2>
            <h2>Password:
            <input type="password" id="password-input" class="username-input" placeholder="Password" autocomplete="current-password" onkeydown="event.stopPropagation()"></h2>
            <p id="login-error" class="login-error">Login incorrect. Please try again.</p>
            </form>
            <form onsubmit="return false;" autocomplete="off">
            <h2>Room:
            <input type="text" id="room-input" class="username-input" placeholder="Room name (e.g., lobby)" autocomplete="off" onkeydown="event.stopPropagation()"></h2>
            <h2>Room Password <span style="font-weight:400;font-size:0.85em;text-transform:none;letter-spacing:0">(optional)</span>:
            <input type="password" id="room-password-input" class="username-input" placeholder="Leave blank for open room" autocomplete="new-password" onkeydown="event.stopPropagation()"></h2>
            <p id="room-password-error" class="login-error">Room password incorrect. Please try again.</p>
            <p id="room-join-error" class="login-error"></p>
            </form>
            <h2>Share Microphone:
            <input type="checkbox" id="share-mic-input" class="username-input" placeholder="Sharemic"></h2>
            <h2>Headless Mode (for video and device sharing):
            <input type="checkbox" id="headless-mode-input" class="username-input" placeholder="Headless Mode"></h2>
            <button id="submit-button" class="submit-button">Connect</button>
        </div>
`;

export interface AgeVerificationModalOptions {
    ageModal: HTMLDivElement;
    userModal: HTMLDivElement;
    addTrackedEventListener: (element: HTMLElement, event: string, handler: EventListener) => void;
    onConfirm: () => void;
    onDeny: () => void;
}

export interface UsernameModalOptions {
    userModal: HTMLDivElement;
    addTrackedEventListener: (element: HTMLElement, event: string, handler: EventListener) => void;
    username: string;
    roomName: string;
    sharemic: boolean;
    headlessmode: boolean;
    showLoginError?: boolean;
    showRoomPasswordError?: boolean;
    showRoomJoinError?: string;
    onSubmit: (values: { username: string; password: string; room: string; roomPassword: string; sharemic: boolean; headlessmode: boolean }) => void;
}

export function createAgeModalContainer(): HTMLDivElement {
    const modal = document.createElement('div');
    modal.classList.add('modal-container');
    modal.id = 'modal-container-age';
    modal.innerHTML = AGE_MODAL_HTML;
    return modal;
}

export function createUserModalContainer(): HTMLDivElement {
    const modal = document.createElement('div');
    modal.classList.add('modal-container');
    modal.id = 'modal-container';
    modal.innerHTML = USER_MODAL_HTML;
    return modal;
}

export function openAgeVerificationModal(options: AgeVerificationModalOptions): void {
    const confirmBtn = options.ageModal.querySelector<HTMLButtonElement>('#age-confirm-button');
    const denyBtn = options.ageModal.querySelector<HTMLButtonElement>('#age-deny-button');

    if (!confirmBtn || !denyBtn) return;

    options.ageModal.style.display = 'flex';
    options.userModal.style.display = 'none';

    options.addTrackedEventListener(confirmBtn, 'click', () => {
        options.ageModal.style.display = 'none';
        options.onConfirm();
    });

    options.addTrackedEventListener(denyBtn, 'click', () => {
        options.onDeny();
    });
}

export function openUsernameModal(options: UsernameModalOptions): void {
    const btn = options.userModal.querySelector<HTMLButtonElement>('#submit-button');
    const input = options.userModal.querySelector<HTMLInputElement>('#username-input');
    const passwordInput = options.userModal.querySelector<HTMLInputElement>('#password-input');
    const roomInput = options.userModal.querySelector<HTMLInputElement>('#room-input');
    const roomPasswordInput = options.userModal.querySelector<HTMLInputElement>('#room-password-input');
    const sharemic = options.userModal.querySelector<HTMLInputElement>('#share-mic-input');
    const headlessmode = options.userModal.querySelector<HTMLInputElement>('#headless-mode-input');
    const loginError = options.userModal.querySelector<HTMLParagraphElement>('#login-error');
    const roomPasswordError = options.userModal.querySelector<HTMLParagraphElement>('#room-password-error');
    const roomJoinError = options.userModal.querySelector<HTMLParagraphElement>('#room-join-error');

    if (!btn || !input || !passwordInput || !roomInput || !roomPasswordInput || !sharemic || !headlessmode) return;

    options.userModal.style.display = 'flex';
    input.value = options.username;
    roomInput.value = options.roomName;
    sharemic.checked = options.sharemic;
    headlessmode.checked = options.headlessmode;

    if (loginError) {
        loginError.classList.toggle('visible', !!options.showLoginError);
    }
    if (roomPasswordError) {
        roomPasswordError.classList.toggle('visible', !!options.showRoomPasswordError);
    }
    if (roomJoinError) {
        if (options.showRoomJoinError) {
            roomJoinError.textContent = options.showRoomJoinError;
            roomJoinError.classList.add('visible');
        } else {
            roomJoinError.textContent = '';
            roomJoinError.classList.remove('visible');
        }
    }

    // Clear password fields each time the modal opens (never persist passwords)
    passwordInput.value = '';
    roomPasswordInput.value = '';

    options.addTrackedEventListener(btn, 'click', () => {
        const username = input.value;
        if (username === '') return;
        const password = passwordInput.value;
        if (password === '') return;

        options.onSubmit({
            username,
            password,
            room: roomInput.value.trim(),
            roomPassword: roomPasswordInput.value,
            sharemic: sharemic.checked,
            headlessmode: headlessmode.checked,
        });
    });
}
